import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import useApi from "../../hook/useApi";
import Paggination from "../Paggination";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import { useNavigate } from "react-router-dom";
import AirdropTransactionsLayer from "./AirdropTransactionsLayer";

const AirdropDashboardLayer = () => {
     const { AsyncGetApiCall, } = useApi();

     const [query, setQuery] = useState({
          pageNo: 1,
          limitVal: 50,
          search: "",
     });
     const [loading, setLoading] = useState(false);
     const navigate = useNavigate();

     const setPageNo = (pageNo) => {
          setQuery((prev) => ({
               ...prev,
               pageNo: pageNo,
          }));
     };

     return (
          <div className="card h-100 p-0 radius-12">
               {loading && <Loader />}
               <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                    <h6 className="fw-medium">Airdrop Transactions</h6>
                    <div className="d-flex align-items-center gap-10 btn btn-primary"
                         onClick={() => {
                              navigate("/campaign-manage/bulk-upload");
                         }}
                    >
                         <button type="button">
                              Bulk Upload
                         </button>
                         <Icon icon="ic:baseline-upload" className="icon text-xl" />
                    </div>
               </div>
               <AirdropTransactionsLayer />
          </div>
     );
};

export default AirdropDashboardLayer;